import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Platform } from "@core/api";
import dayjs from "dayjs";
var LOCAL_STORAGE_KEY = "coveo-access-token";
var defaults = Object.freeze({
    token: "",
    expiration: 0
});
var getSaved = function() {
    var stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored === null) {
        // nothing stored
        return Object.assign({}, defaults);
    }
    try {
        var saved = JSON.parse(stored);
        return Object.assign({}, defaults, saved);
    } catch (e) {
        console.error(e);
        return Object.assign({}, defaults);
    }
};
var checkToken = function() {
    var _ref = _async_to_generator(function() {
        var e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Platform.initialize()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function checkToken() {
        return _ref.apply(this, arguments);
    };
}();
export var AccessTokenUtils = {
    checkToken: checkToken,
    getToken: function() {
        return getSaved().token;
    },
    setToken: function(token, expires) {
        var expiration = dayjs().add(expires, "seconds").valueOf();
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
            token: token,
            expiration: expiration
        }));
    },
    getExpiration: function() {
        return getSaved().expiration;
    },
    clear: function() {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
};

//# sourceMappingURL=AccessTokenUtils.js.map